import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-subtitle1 full-width"
}
const _hoisted_2 = {
  key: 1,
  class: "selected-nodes full-width"
}
const _hoisted_3 = { class: "selected-node_label" }
const _hoisted_4 = {
  key: 2,
  class: "text-brand-grey"
}
const _hoisted_5 = {
  key: 1,
  class: "full-width"
}

import { random, range } from 'lodash';
import { QTree } from 'quasar';
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue';

import {
  BaseFieldEmits,
  ValuedFieldProps,
  defaultValuedProps,
  useBaseFieldProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import SSkeletonItem from 'SharedComponents/ui/SSkeletonItem.vue';
import Tooltip from 'SharedComponents/ui/Tooltip.vue';
import { CatalogsApi } from 'SharedDir/backend/api';
import { MakeRequestOptions, makeRequest } from 'SharedDir/common/composables/useRequests';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { Catalogs } from 'SharedDir/declarations/catalogs';
import { FieldValue, TreeSelectFieldParams } from 'SharedDir/declarations/fields';

type Node = {
  value: string | number;
  label: string;
  children: Array<Node>;
  lazy?: boolean;
  tickable: boolean;
};

type ValueType = FieldValue<null | string | number | Array<number> | Array<string>>;
type DynamicTableFieldProps = ValuedFieldProps &
  PropValue<ValueType> & { params: TreeSelectFieldParams };


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'TreeSelectLazyField', filters: { random } },
  __name: 'TreeSelectField',
  props: /*@__PURE__*/_mergeDefaults({
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    modelValue: {},
    params: {}
  }, {
  ...defaultValuedProps,
  label: '',
}),
  emits: ["update:modelValue", "reveal-history"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable no-underscore-dangle,@typescript-eslint/naming-convention */
const makeNode = (
  rawValue: Catalogs.CatalogsValueFull,
  lazy: boolean = true,
  tickable: boolean = true
): Node => ({
  value: rawValue.id as number,
  label: rawValue.name,
  lazy,
  children: [],
  tickable,
});

const setTickable = (
  nodes: Array<Node>,
  exceptions: Array<Node['value']>,
  state: boolean
): void => {
  nodes.forEach((node) => {
    if (!exceptions.includes(node.value) && node.tickable !== state) {
      // eslint-disable-next-line no-param-reassign
      node.tickable = state;
    }
    if (node.children.length > 0) {
      setTickable(node.children, exceptions, state);
    }
  });
};



const props = __props;
const emit = __emit;

const setInnerValue = (modelValue: ValueType) => {
  // eslint-disable-next-line prefer-const
  let { value, expanded } = modelValue;
  if (props.params.multiple) {
    if (value !== null && !Array.isArray(value)) {
      value = [value] as Array<string> | Array<number>;
    }
  } else if (Array.isArray(value) && value.length > 0) {
    value = [value[0]] as Array<string> | Array<number>;
  } else if (value !== null) {
    value = [value] as Array<string> | Array<number>;
  } else {
    value = [];
  }
  return { value, expanded };
};

const { innerValue, emitValue } = useValue(props, emit, {
  transform: (modelValue) => {
    return setInnerValue(modelValue);
  },

  mrofsnart: (iv: FieldValue) => {
    if (!props.params.multiple && Array.isArray(iv.value)) {
      iv.value = iv.value[0] as string | number | null;
    }
    return iv;
  },
  onRefresh: async ({ value: newValue }, { value: oldValue }) => {
    // console.debug(newValue, oldValue);
    // if (newValue !== oldValue && props.params.catalogSlug) {
    //   await loadRoots(props.params.catalogSlug as unknown as Catalogs.CatalogSlug);
    // }
  },
});

const { validationErrorStatus, hasHistory, revealHistory } = useBaseFieldProps(props, emit);

let options = reactive<Array<Node>>([]);
const loading = ref(false);
const catalogLoaded = ref(false);
const rootsLoaded = ref(false);
const QTreeElement = ref(null as unknown as QTree);
const sekeletonLines = reactive(range(0, 13));
const filter = ref('');

const requestOptions: Partial<MakeRequestOptions> = {
  startLoading: () => {
    loading.value = true;
  },
  finishLoading: () => {
    loading.value = false;
  },
};

const maxAvailableTicked = computed(() => {
  if (props.params.multiple) {
    return props.params.maxElements || null;
  }

  return 1;
});

const maxTicksExceed = computed(() => {
  if (!props.params.multiple) {
    return false;
  }
  if (
    !innerValue.value.value ||
    !Array.isArray(innerValue.value.value) ||
    maxAvailableTicked.value === null
  ) {
    return false;
  }
  return innerValue.value.value.length >= maxAvailableTicked.value;
});

const selectedNodes = computed((): Array<Node> => {
  const a = rootsLoaded.value;
  const b = innerValue.value;
  return QTreeElement.value?.getTickedNodes().filter((node) => node) || [];
});

const enableDisableCheckboxes = (target: Array<Node['value']>) => {
  if (!props.params.multiple) {
    innerValue.value.value = [target[target.length - 1]];
    setTickable(options, target, true);
  } else if (maxTicksExceed.value || props.readonly) {
    setTickable(options, target, false);
  } else {
    setTickable(options, target, true);
  }
  emitValue();
};

const removeNode = (node: Node) => {
  if (Array.isArray(innerValue.value.value)) {
    const index = innerValue.value.value.findIndex((id) => id === node.value);
    if (index !== -1) {
      innerValue.value.value.splice(index, 1);
      enableDisableCheckboxes(innerValue.value.value);
    }
  } else {
    innerValue.value.value = null;
  }
};

const getChildrenNodes = async (
  parentId: number,
  tickable: (rawValue: Catalogs.CatalogsValueFull) => boolean
) => {
  console.debug('Getting child nodes...');
  const request = CatalogsApi.ValuesApi(
    props.params.catalogSlug as unknown as Catalogs.CatalogSlug
  ).getAllValues({ parentId });
  const { values } = await makeRequest(() => request, requestOptions);
  return values.map((value) => makeNode(value, true, tickable(value)));
};

/**
 * Рекурсивно загружаем все ноды которые должны быть распахнутыми
 */
const loadExpandedRecursively = async (option: Node) => {
  if (innerValue.value.expanded && innerValue.value.expanded.includes(option.value)) {
    const childrenNodes = getChildrenNodes(
      option.value as number,
      (value) =>
        !maxTicksExceed.value ||
        (innerValue.value.value as Array<Node['value']>).includes(value.id as number)
    );
    const childrenWaiters = (await childrenNodes).map(loadExpandedRecursively);
    const children = await Promise.all(childrenWaiters);
    return { ...option, children, lazy: undefined };
  }
  return option;
};

const setTickableFunction = (alreadyTicked) => (value) =>
  !maxTicksExceed.value || alreadyTicked.includes(value.id as number);

/**
 * Загружаем сначала корневые элементы дерева,
 * а так же подгружаем всех детей рекурсивно если они должныбыть раскрыты.
 *
 * Делаем это вручную потому что нативное поведение
 * q-tree несрабатывает если ноды подгружаются асинхронно
 */
async function loadRoots(catalogSlug: Catalogs.CatalogSlug) {
  try {
    const { values } = await makeRequest(
      () => CatalogsApi.ValuesApi(catalogSlug).getAllValues({ onlyRoot: true }),
      requestOptions
    );
    const _options = values.map(
      (value) => makeNode(value, true, setTickableFunction(innerValue.value.value ?? [])(value))
      // makeNode(value, true, !(props.readonly || maxTicksExceed.value))
    );
    options = await Promise.all(_options.map(loadExpandedRecursively));
  } finally {
    catalogLoaded.value = true;
    await nextTick();
    rootsLoaded.value = true;
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const loadLeaves = async ({ key: parentId, done, fail }) => {
  console.debug('Loading leaves ...');
  try {
    let alreadyTicked: Array<Node['value']> = [];
    if (innerValue.value.value) {
      alreadyTicked = innerValue.value.value as Array<Node['value']>;
    }
    done(await getChildrenNodes(parentId, setTickableFunction(alreadyTicked)));
  } catch {
    fail();
  }
};

watch(
  () => props.readonly,
  () => {
    if (Array.isArray(innerValue.value.value)) {
      enableDisableCheckboxes(innerValue.value.value || []);
    } else if (innerValue.value.value) {
      enableDisableCheckboxes([innerValue.value.value]);
    }
  }
);

watch(
  () => props.params.catalogSlug,
  (newCatalogSlug) => {
    if (newCatalogSlug) {
      catalogLoaded.value = false;
      loadRoots(newCatalogSlug as unknown as Catalogs.CatalogSlug);
    }
  }
);

watch(
  () => [props.params.multiple, props.params.maxElements],
  () => {
    innerValue.value = setInnerValue(props.modelValue);
    // fixme: По какой-то причине если эмитить событие смены значения при изменении параметров запускается рекурсивный апдейт
    // emitValue();
  }
);

onMounted(async () => {
  if (props.params.catalogSlug) {
    await loadRoots(props.params.catalogSlug as unknown as Catalogs.CatalogSlug);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_s_input = _resolveComponent("s-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row tree-select", { readonly: _ctx.readonly }])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (selectedNodes.value.length > 0)
      ? (_openBlock(), _createElementBlock("figure", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("figcaption", { class: "text-brand-grey" }, "Выбранные элементы", -1)),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedNodes.value, (node) => {
              return (_openBlock(), _createElementBlock("li", {
                key: node.value
              }, [
                (!_ctx.readonly)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      class: "remove",
                      name: "las la-times",
                      onClick: ($event: any) => (removeNode(node))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_3, _toDisplayString(node.label), 1)
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_4, " Не выбрано ни одного значение ")),
    (!_ctx.readonly)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createVNode(_component_s_input, {
            modelValue: filter.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
            class: "full-width base-margin-bottom",
            label: "Поиск по дереву",
            clearable: "",
            outlined: "",
            dense: "",
            "hide-bottom-space": "",
            readonly: _ctx.readonly,
            disable: _ctx.disable,
            error: _unref(validationErrorStatus),
            "error-message": _ctx.errorMessage
          }, {
            prepend: _withCtx(() => [
              _createVNode(Tooltip, {
                class: _normalizeClass({ shaking: loading.value || !catalogLoaded.value }),
                text: "Поиск работает только с уже раскрытыми значениями"
              }, null, 8, ["class"])
            ]),
            append: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "app:search" })
            ]),
            _: 1
          }, 8, ["modelValue", "readonly", "disable", "error", "error-message"]),
          (catalogLoaded.value)
            ? (_openBlock(), _createBlock(_unref(QTree), {
                key: 0,
                ref_key: "QTreeElement",
                ref: QTreeElement,
                ticked: _unref(innerValue).value,
                "onUpdate:ticked": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_unref(innerValue).value) = $event)),
                  enableDisableCheckboxes
                ],
                expanded: _unref(innerValue).expanded,
                "onUpdate:expanded": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_unref(innerValue).expanded) = $event)),
                  _unref(emitValue)
                ],
                class: "full-width max-height-400",
                nodes: _unref(options),
                "node-key": "value",
                "label-key": "label",
                "tick-strategy": "strict",
                filter: filter.value,
                onLazyLoad: loadLeaves
              }, null, 8, ["ticked", "expanded", "nodes", "filter", "onUpdate:expanded"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sekeletonLines, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "row col-xs-12 base-margin-bottom"
                  }, [
                    _createVNode(SSkeletonItem, {
                      class: _normalizeClass(`col-xs-${_unref(random)([4, 11])}`),
                      loading: ""
                    }, null, 8, ["class"])
                  ]))
                }), 128))
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}
}

})